/* eslint-disable no-restricted-globals */
import { useEditor, EditorContent } from "@tiptap/react";
import { generateHTML } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableRow from "@tiptap/extension-table-row";
import TableHeader from "@tiptap/extension-table-header";
import Paragraph from "@tiptap/extension-paragraph";
import Link from "@tiptap/extension-link";

import { AddUUID } from "./extensions/add-uuid";
import { SetProposalNodes } from "./extensions/proposals-setter";
import { useAuth } from "../../../../../utils/hooks/useAuth";
import { IDocument } from "../../../../../types/IDocument";

import "./styles.css";

interface TipTapProps {
  doc: IDocument;
  onSaveDocState: (payload: Object) => void;
  editable?: boolean;
}

const CustomParagraph = Paragraph.extend({
  draggable: false,

  renderHTML({ HTMLAttributes, node }) {
    // Remove empty paragraphs
    if (node.content.size <= 1) {
      return ["br"];
    }

    return ["p", HTMLAttributes, 0];
  },
});

const Tiptap = (props: TipTapProps) => {
  const { doc, onSaveDocState, editable = false } = props;

  const { isAuthorized } = useAuth();

  const setProposalNodesMaybe = isAuthorized
    ? [SetProposalNodes.configure({ documentId: doc.id })]
    : [];

  let extensions = [
    StarterKit,
    Table.configure({
      allowTableNodeSelection: true,
    }),
    TableHeader,
    TableCell,
    TableRow,
    CustomParagraph,
    Link,
    AddUUID,
    ...setProposalNodesMaybe,
  ];

  let content: string;
  if (doc.contentJson) {
    try {
      content = generateHTML(JSON.parse(doc.contentJson), extensions);
    } catch (error) {
      content = doc.content;
    }
  } else {
    content = doc.content;
  }

  const editor = useEditor({
    extensions,
    content,
    editable,
    onCreate() {
      if (!doc.contentJson) {
        const json = this.getJSON();
        onSaveDocState({
          billId: doc.billId,
          documentId: doc.id,
          payload: {
            contentJson: JSON.stringify(json),
            content: generateHTML(json, extensions),
          },
        });
      }
    },
  });

  return editor && <EditorContent editor={editor} />;
};

export default Tiptap;
